import { DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { TenantService } from 'src/app/core/services/tenant.service';
import { Invite } from 'src/app/core/services/user.service';
import { OrderBy } from 'src/app/shared/models/order-by.model';
import { PagedResult } from 'src/app/shared/models/paged-result.model';

export class InvitesDataSource implements DataSource<Invite> {
  private _invites = new BehaviorSubject<Invite[]>(undefined);
  private _loading = new BehaviorSubject<boolean>(false);
  public loading$ = this._loading.asObservable();
  public total: number;
  public get length(): number {
    return this._invites.value ? this._invites.value.length : -1;
  }
  public get data(): Invite[] {
    return this._invites.value?.slice() || [];
  }

  constructor(private tenantSvc: TenantService) {}

  loadInvites(filter: string, limit: number, page: number, orderBy: OrderBy[]): void {
    this._loading.next(true);

    this.tenantSvc
      .getAllInvites(filter, limit, page, orderBy)
      .pipe(
        catchError(() => of([])),
        finalize(() => this._loading.next(false))
      )
      .subscribe({
        next: (results: PagedResult<Invite>) => {
          this.total = results.count;
          this._invites.next(results.items || []);
        }
      });
  }

  connect(): Observable<Invite[]> {
    return this._invites.asObservable();
  }

  disconnect(): void {
    this._invites.complete();
    this._loading.complete();
  }
}
